<template>
    <FloatingPanel title="Kernenkaart (kaart)">
        <div class="initiatief::canvas-blocks-modules-kernenkaart-map-BlockPanel">
            <ColorsInput
                label="Achtergrondkleur kaart"
                instruction="Bepaal hier de achtergrondkleur van het blok achter de kaart."
                :colors="colors"
                :options="options"
                options-property="cardColor"
                :open="true"
            />

            <CommonInputs :options="options"/>
        </div>
    </FloatingPanel>
</template>

<script>
import AbstractPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel';
import FloatingPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel';
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";
import ColorsInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/ColorsInput";
import getDatabaseColors from "@galaxy/modules/Canvas/resources/components/canvas/blocks/utils/text/admin/getDatabaseColors";

export default {
    extends: AbstractPanel,
    components: { FloatingPanel, CommonInputs, ColorsInput },

    data() {
        return {
            colors: null,
        }
    },

    mounted() {
        this.loadColors();
    },

    methods: {
        async loadColors() {
            let databaseColors = (await getDatabaseColors(true)).data;

            this.colors = [
                'transparent',
                'white',
                'black',
            ];

            Object.entries(databaseColors).forEach(([item, value]) => {
                if (typeof value !== 'string') {
                    this.colors.push(...Object.values(value));
                } else {
                    this.colors.push(value);
                }
            });

            this.colors = [...new Set(this.colors)];

            let formattedColors = {};

            for (const color of this.colors) {
                if (typeof color === 'object') {
                    for (const [key, value] of Object.entries(color)) {
                        formattedColors[key] = value;
                    }
                } else {
                    formattedColors[color] = color;
                }
            }

            this.colors = formattedColors;
        },
    },
}
</script>

<style lang="scss" scoped>
.initiatief\:\:canvas-blocks-modules-kernenkaart-map-BlockPanel { }
</style>
